import { Route, Redirect } from "react-router-dom";
import React from "react";
// import { store } from '../../../redux/store';

const PublicRoute = ({ component: Component, ...rest }) => {
  // const state = store.getState();
  // console.log(state1);
  let state = localStorage.getItem("user")
  if (state) {
    state = JSON.parse(state)
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (state && state.userData && state.userData.token) {
          return (
            <Redirect
              to={{
                pathname: rest.redirectRoute,
                extras: { ...rest.location },
              }}
            />
          );
        } else {
          return <Component {...props} />;
        // return <Component {...props} />
        }
      }}
    />
  );
};

export default PublicRoute;
